module.exports = __webpack_public_path__ + "img/web5.3c02a9e7.png";